import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { SessionService } from '../services/session.service';

export const clientResolver = () => {
	const sessionService: SessionService = inject(SessionService);
	const router: Router = inject(Router);

	if (sessionService.clients?.length) {
		return router.navigate(sessionService.getLink(''));
	}
	return false;
}